import { ConfirmReceiptState } from './confirmReceipt.types'

export const confirmReceiptInitialState: ConfirmReceiptState = {
  loading: false,
  error: null,
  success: null
}

export default confirmReceiptInitialState
